
interface IProps {
  color?: string;

}

export const YoutubeFilled = ({color="#010201"}: IProps) => {
  return (
    <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.5 61C50.9264 61 61 50.9264 61 38.5C61 26.0736 50.9264 16 38.5 16C26.0736 16 16 26.0736 16 38.5C16 50.9264 26.0736 61 38.5 61Z" fill={color}/>
      <path d="M52.8733 31.28C52.53 29.99 51.5133 28.9733 50.22 28.6267C47.88 28 38.5 28 38.5 28C38.5 28 29.12 28 26.78 28.6267C25.49 28.9733 24.4733 29.9867 24.1267 31.28C23.5 33.62 23.5 38.5 23.5 38.5C23.5 38.5 23.5 43.38 24.1267 45.72C24.47 47.01 25.4867 48.0267 26.78 48.3733C29.12 49 38.5 49 38.5 49C38.5 49 47.88 49 50.22 48.3733C51.51 48.0267 52.5267 47.0133 52.8733 45.72C53.5 43.38 53.5 38.5 53.5 38.5C53.5 38.5 53.5 33.62 52.8733 31.28ZM35.5 43V34L43.2933 38.5L35.5 43Z" fill="white"/>
    </svg>
  )
}